const state = {
    routesObj: null,
    searchObj: null,
    arrivalLs:[]
};

const getters = {
    GET_ROUTES_OBJ: (state) => {
        return state.routesObj;
    },
    GET_SEARCH_OBJ: (state) => {
        return state.searchObj;
    },
    GET_ARR_LS: (state) => {
        return state.arrivalLs;
    },
};


const actions = {

    CLEAR_CSEARCH_STORE: ({ commit }) => {
        commit('clearCSearchStore');
    },
    SET_ROUTES_OBJ: ({ commit }, routes) => {

        commit('saveRoutesObj', routes);

    },
    SET_SEARCH_OBJ: ({ commit }, search) => {

        commit('saveSearchObj', search);

    },
    SET_ARR_LS: ({ commit }, arrLs) => {

        commit('saveArrList', arrLs);

    },

};


const mutations = {
    clearCSearchStore: (state) => {
        state.routesObj = null;
        state.searchObj = null;
        state.arrivalLs=[];
       
    },

    saveRoutesObj: (state, routes) => {
        state.routesObj = routes;
    },
    saveSearchObj: (state, search) => {
        state.searchObj = search;
       
    },
    saveArrList: (state, arrLs) => {
        
        state.arrivalLs=arrLs;
    },

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}